// Keep Shopify's broad matching, but do not lose literal titles to language expansion.
window.okazoSearchResults = async (searchTerm, signal) => {
  const sectionId = "okazo-next-predictive-search";
  const load = async (query, requestSignal = signal) => {
    const params = new URLSearchParams({
      q: query,
      "resources[limit]": "7",
      "resources[type]": "product,collection",
      section_id: sectionId,
    });
    const response = await fetch(`${window.routes.predictive_search_url}?${params}`, { signal: requestSignal });
    if (!response.ok) throw new Error(`Search: ${response.status}`);
    const html = new DOMParser().parseFromString(await response.text(), "text/html");
    const section = html.querySelector(`#shopify-section-${sectionId}`);
    if (!section) throw new Error("Missing search section");
    return section;
  };
  const exactQuery = searchTerm.length >= 2 && !/[":*]/.test(searchTerm);
  const exactController = new AbortController();
  const cancelExact = () => exactController.abort();
  signal.addEventListener("abort", cancelExact, { once: true });
  const exactTimeout = setTimeout(cancelExact, 1500);
  let results, exact;
  try {
    [results, exact] = await Promise.all([
      load(searchTerm),
      exactQuery ? load(`"${searchTerm}"`, exactController.signal).catch(() => null) : null,
    ]);
  } finally {
    clearTimeout(exactTimeout);
    signal.removeEventListener("abort", cancelExact);
    exactController.abort();
  }
  const products = results.querySelector("[data-okz-search-products]");
  const titleMatches = [...(exact?.querySelectorAll("[data-okz-search-product]") || [])].filter(
    (link) =>
      link.querySelector("strong")?.textContent.trim().localeCompare(searchTerm, "fr", { sensitivity: "base" }) === 0,
  );
  if (products && titleMatches.length) {
    const seen = new Set();
    const suggestions = [...titleMatches, ...products.children].filter((link) => {
      const id = link.dataset.okzSearchProduct;
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
    products.replaceChildren(...suggestions.slice(0, 5));
    results.querySelector("[data-okz-search-empty]")?.remove();
  }
  return results;
};
